/**
 * @deprecated Kept for compatibility with older versions.
 */
export enum WidgetName {
  SystemInformation = 'System Information',
  SystemInformationStandby = 'System Information(Standby)',
  Cpu = 'CPU',
  Memory = 'Memory',
  Storage = 'Storage',
  Network = 'Network',
  Interface = 'Interface',
  Pool = 'Pool',
  Help = 'Help',
  Backup = 'Backup',
}
